export default "__VITE_ASSET__BVF9bvP0__"